var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { EntityValue } from '../entities/entity-value';
import { EmptyIconGlyph } from '@shapeable/icons';
var cls = classNames('option-menu-item-placeholder-entity-value');
export var OptionMenuInputPlaceholderEntityValueDefaultProps = {
  valueProps: {
    variant: 'card',
    imageSize: 38
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    user-select: none;\n    color: inherit;\n\n    .shp--cell-label,\n    .shp--cell-header {\n      color: ", ";\n    }\n\n    .shp--entity-value__name {\n      color: ", ";\n    }\n\n\n  "], ["\n    ", "\n    user-select: none;\n    color: inherit;\n\n    .shp--cell-label,\n    .shp--cell-header {\n      color: ", ";\n    }\n\n    .shp--entity-value__name {\n      color: ", ";\n    }\n\n\n  "])), theme.APPLY_COLORS({
    colors: {
      fill: 'subtle'
    },
    selector: '.shp--icon'
  }), theme.COLOR('sub'), theme.COLOR('sub'))
});
// -------- Components -------->
var My = {
  NAME: 'OptionMenuInputPlaceholderEntityValue',
  Container: styled(EntityValue)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var OptionMenuInputPlaceholderEntityValue = function (props) {
  var componentProps = useComponentProps(My.NAME, OptionMenuInputPlaceholderEntityValueDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    placeholder = componentProps.placeholder,
    label = componentProps.label,
    _a = componentProps.valueProps,
    valueProps = _a === void 0 ? {} : _a;
  var __icon = EmptyIconGlyph;
  var emptyValue = {
    id: '',
    name: placeholder,
    label: label,
    typeLabel: label,
    __icon: __icon
  };
  return React.createElement(My.Container, __assign({}, valueProps, {
    entity: emptyValue,
    className: cls.name(className)
  }));
};
OptionMenuInputPlaceholderEntityValue.cls = cls;
var templateObject_1, templateObject_2;